var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col margin-history"},[_c('NewsPanel')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }